import styled from 'styled-components';

const Wrapper = styled.main`
  grid-area: main;
  height: 100%;
  min-height: calc(100vh - 80px);
  min-width: 950px;

  .content-container {
    margin: 24px;
  }
`;

export default { Wrapper };
